import { put, takeLatest } from 'redux-saga/effects';
import { SpaceAPI } from 'api/space/space';
import { editSpaceSagaAction } from '../actions';
import { editStart, editSuccess, editFailure } from '../index';
function* editSpaceSaga(action) {
    const { payload } = action;
    try {
        const { spaceId, ...rest } = payload;
        yield put(editStart(spaceId));
        const response = yield SpaceAPI.updateSpace(spaceId, rest);
        yield put(editSuccess(response));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        yield put(editFailure(''));
    }
}
export function* watchEditSpaceSaga() {
    yield takeLatest(editSpaceSagaAction.type, editSpaceSaga);
}
